import { LaunchDarklySettingsModel } from "@MasterBluePrint/Types/ApiModels";
import { initialize, LDClient } from "launchdarkly-js-client-sdk";

let ldClient: LDClient | null = null;

const initializeLDClient = (clientId: string) => {
    if (!ldClient) {
        ldClient = initialize(clientId, { key: "anonymous-user" });
    }
}

export const getFeatureFlag = (customSettings: LaunchDarklySettingsModel, flagKey: string): Promise<boolean> => {
    if (customSettings?.useLaunchDarkly) {
        initializeLDClient(customSettings.launchDarklyClientId);

        return new Promise((resolve) => {
            if (ldClient) {
                ldClient.on("ready", () => {
                    const flagValue = ldClient?.variation(flagKey, false);
                    resolve(flagValue);
                });
            } else {
                resolve(false);
            }
        });
    }
    return Promise.resolve(false);
} 